<template>
  <div>
    <congrats-menu active="Nacimientos" />

    <v-layout row wrap>
      <v-flex sm12 text-md-right>
       <v-btn class="text-14-security" to="/celebremos-nacimientos/create" flat>
          <v-icon left color="#28385C" style="margin-right: 4px;">add_circle</v-icon>
          Crear Nacimiento
        </v-btn>
      </v-flex>
      <v-flex md1 pt-2 hidden-xs-only>
        <div class="fixed-celebration-buttons">
          <v-btn
            v-for="date in dates"
            :key="date"
            :color="date == datePicker ? '#28385C' : 'white'"
            block
            class="btn-primary-security text-14-security"
            :class="date == datePicker ? 'white--text font-weight-bold' : ''"
            @click="changeDatePicker(date)"
            :disabled="todayMonth <= dates.indexOf(date) -1 "
          >{{date}}</v-btn>
        </div>
      </v-flex>

      <v-flex hidden-sm-and-up>
        <v-select
          :items="dates"
          v-model="datePicker"
          label="Fecha"
          outline
          @change="changeDatePicker(datePicker)"
        ></v-select>
      </v-flex>

      <v-flex xs12 md11 :class="{'pt-2 pl-4': $vuetify.breakpoint.mdAndUp}">
        <birth-infinite
          :date="datePicker"
          :monthNumber="dates.indexOf(datePicker) + 1"
          :key="datePicker"
        ></birth-infinite>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import BirthInfinite from "./BirthInfinite";
import CongratsMenu from "../General/CongratsMenu";
import axios from "axios";
import { mapMutations, mapState } from "vuex";
import config from "@/config";
export default {
  components: {
    BirthInfinite,
    CongratsMenu
  },
  data() {
    return {
      page: 1,
      list: [],
      dates: [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
      ],
      datePicker: "enero",
      todayMonth: new Date().getMonth()
    };
  },
  methods: {
    changeDatePicker(date) {
      this.datePicker = date;
    }
  },
  mounted() {
    this.datePicker = this.dates[this.todayMonth];
  }
};
</script>
